// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gVQ5J","content":"styles_content__1DZM3","row":"styles_row__2eCF3","footer":"styles_footer__c6qAc","phraseLength":"styles_phraseLength__1BP-B"};